import { render } from "./CTAbanner.vue?vue&type=template&id=7e5f2e50&scoped=true"
import script from "./CTAbanner.vue?vue&type=script&lang=js"
export * from "./CTAbanner.vue?vue&type=script&lang=js"

import "./CTAbanner.vue?vue&type=style&index=0&id=7e5f2e50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5f2e50"]])

export default __exports__